import { useReportJobs } from "./rater/useIntegrationJobs";
import { TooltipWrapper } from "../../components/tooltip/TooltipWrapper";
import styles from "./FunctionRegenIndicator.module.css";

const REGEN_FUNCTIONS = "REGEN_FUNCTIONS";

/** Whether a limit/deductible function regen is queued or running for the report. */
export const useRegenFunctionsInProgress = (reportId: string): boolean => {
  const { jobs } = useReportJobs(reportId, {
    integrationTypes: [REGEN_FUNCTIONS],
  });
  return jobs.some(
    (batch) =>
      batch.finished_at === null &&
      batch.jobs.some(
        (job) => job.status === "pending" || job.status === "in_progress"
      )
  );
};

/**
 * Card title for the Limits / Deductible cards: the plain title, plus a
 * spinner pill while a function regen is in flight so it's clear the
 * functions below are about to change.
 */
export const FunctionCardTitle: React.FC<{
  title: string;
  reportId: string;
}> = ({ title, reportId }) => {
  const regenerating = useRegenFunctionsInProgress(reportId);
  return (
    <div className={styles.titleRow}>
      <span>{title}</span>
      {regenerating && (
        <TooltipWrapper
          tooltipText="Limit and deductible functions are being regenerated. The functions shown here update when it finishes."
          tooltipProps={{ position: "top" }}
        >
          <span className={styles.indicator}>
            <i className="pi pi-spin pi-spinner" />
            Regenerating functions
          </span>
        </TooltipWrapper>
      )}
    </div>
  );
};
